export const SubstepNavigationChipStates = Object.freeze({
    Available: 'available',
    Active: 'active',
    Done: 'done',
    Locked: 'locked'
});

export type SubstepNavigationChipState = (typeof SubstepNavigationChipStates)[keyof typeof SubstepNavigationChipStates];
